module.exports = __webpack_public_path__ + "img/twoIm.45ba2f8d.png";